import { render, staticRenderFns } from "./AddPictureGame.vue?vue&type=template&id=a7382914&scoped=true&"
import script from "./AddPictureGame.vue?vue&type=script&lang=js&"
export * from "./AddPictureGame.vue?vue&type=script&lang=js&"
import style0 from "./AddPictureGame.vue?vue&type=style&index=0&id=a7382914&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7382914",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VImg,VRadio,VRadioGroup,VRow,VTextField})
